module.exports = {
      id: "humoursatire-entertainment-usage",
      viewBox: "0 0 77 77",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#humoursatire-entertainment",
      toString: function () {
        return this.url;
      }
    }